module.exports = __webpack_public_path__ + "img/32_29.17472463.png";